import React from "react";
import { SquareIntegrationEditor } from "../features/square-integrations";
import { withRestaurantId } from "../shared/components/layout";

const SquareIntegrationEditorWithId = withRestaurantId(SquareIntegrationEditor);

const SquareIntegrationPage: React.FC = () => {
  return <SquareIntegrationEditorWithId />;
};

export default SquareIntegrationPage;
